
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"19","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.592 15.2l-5.217-4.062 1.283-.997 3.467 2.7v.221c0 .76.174 1.489.467 2.138zM3.665 8.13l-1.29-1.005L9.5 1.583l7.125 5.542-1.298 1.005-.562.436a5.109 5.109 0 00-2.494-.65 5.134 5.134 0 00-4.75 3.207L3.665 8.13zM9 18.294h6.83v-.976H9m6.83-4.39h-1.951V10H10.95v2.927H9l3.415 3.415 3.415-3.415z"}})])
          )
        }
      }
    